import { useLenis } from "@/hooks/useLenis";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { MarqueeStrip } from "@/components/landing/MarqueeStrip";
import { Features } from "@/components/landing/Features";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { Waitlist } from "@/components/landing/Waitlist";
import { Footer } from "@/components/landing/Footer";

export default function Landing() {
  useLenis();

  return (
    <div data-testid="landing-page" className="bg-[#07030f] text-white antialiased">
      <Navbar />
      <Hero />
      <MarqueeStrip />
      <Features />
      <HowItWorks />
      <Waitlist />
      <Footer />
    </div>
  );
}
